interface AppEnvConfig {
  apiBase: string;
  googleClientId: string;
  basicAuthProxyBase: string;
  razorpayKeyId: string;
  servicesEmployeesRolesEnabled: boolean;
  membershipsV2Enabled: boolean;
  storeRegistrationOnboardingV2Enabled: boolean;
}

const parseBoolean = (raw: string | undefined): boolean =>
  (raw || '').toLowerCase() === 'true';

export const env: Readonly<AppEnvConfig> = Object.freeze({
  apiBase: process.env.REACT_APP_API_BASE || '',
  googleClientId: process.env.REACT_APP_GOOGLE_CLIENT_ID || '',
  basicAuthProxyBase: process.env.REACT_APP_BASIC_AUTH_PROXY_BASE || '',
  // Public key only. Never put Razorpay key_secret in frontend env.
  razorpayKeyId: process.env.REACT_APP_RAZORPAY_KEY_ID || '',
  // Master gate for the Services + Employees + Roles module (see
  // docs/SERVICES_EMPLOYEES_ROLES_MODULE_ENTERPRISE_PLAN.md). Defaults to false.
  servicesEmployeesRolesEnabled: parseBoolean(
    process.env.REACT_APP_SERVICES_EMPLOYEES_ROLES_ENABLED,
  ),
  // Master gate for the Memberships redesign (see
  // docs/MEMBERSHIPS_REDESIGN_ENTERPRISE_PLAN.md). When false, the legacy
  // MembershipsOverviewPage continues to render. Defaults to false.
  membershipsV2Enabled: parseBoolean(
    process.env.REACT_APP_MEMBERSHIPS_V2_ENABLED,
  ),
  // Master gate for the store registration onboarding redesign. When false,
  // the legacy StorePortal registration remains the active experience.
  storeRegistrationOnboardingV2Enabled: parseBoolean(
    process.env.REACT_APP_STORE_REGISTRATION_ONBOARDING_V2_ENABLED,
  ),
});
